<template>
  <div
    class="tabs-content"
    v-show="active == name"
    v-bind:class="{ opened: opened == name }"
  >
    <div class="tabs-content__inner">
      <slot />
    </div>

    <div class="tabs-content__footer" v-if="!$website.iframeView">
      <div v-if="(selected.length || tickets.length) && !isAdmin">
        <div v-if="tenantId == 70">
          <p class="text-center">
            All events subject to a 6% booking fee.<br />
            Please be considerate when booking tickets and don’t leave gaps
            between seats.<br />
            To book accessible seating please email
            <a href="mailto:info@mountainfest.co.uk">info@mountainfest.co.uk</a
            >.
          </p>
        </div>
        <a
          :href="'/' + $website.tenant_settings.events_slug"
          class="btn btn--tertiary btn--full"
          style="margin-bottom: 20px"
          v-if="$website.tenant_settings.show_continue_shopping"
          >{{ __('Continue Shopping') }}</a
        >
        <a href="/booking" class="btn btn--tertiary btn--full btn-proceed-to-checkout"
          >{{ __('Proceed to Checkout') }}</a
        >
      </div>
      <a
        v-else
        href="#"
        class="btn btn--tertiary btn--full mobile-only"
        @click="handleClose"
        >{{ __('Return') }}</a
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: String,
    active: String,
    selected: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
    tickets: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
    isAdmin: {
      type: Boolean,
      required: false,
      default: false,
    },
    opened: String,
    handleClose: Function,
    tenantId: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.tabs-content {
  position: relative;
  overflow: visible;

  padding: 1.25rem;

  .mobile-only {
    display: none;
  }

  @media screen and (max-width: 650px) {
    position: fixed;
    top: 150%;
    bottom: -150%;
    left: 0;
    right: 0;
    z-index: -1;

    .mobile-only {
      display: block;
    }

    &.opened {
      top: 0;
      bottom: 0;
      z-index: 999999;

      background: rgba(0, 0, 0, 0.5);

      .tabs-content__inner {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        overflow-y: auto;

        display: block;
        padding: 20px 20px 80px 20px;

        background: #ffffff;
      }

      .tabs-content__footer {
        position: absolute;
        bottom: 0;
        right: 0;
        left: 0;

        display: block;
        padding: 20px;

        background: #eee;
        border-top: 1px solid #ddd;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/Tabs/Content.vue